export default {
  getCachedComponents: state => state.cacheComs.cachedComponents,

  getMenuPermissions: state => state.permission.menus,
  getOperatorRole: state => state.permission.role,

  getOperator: state => state.passport.operator
}



// WEBPACK FOOTER //
// ./src/store/getters.js